// Cache Service - Reduz chamadas ao Supabase
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos

export const cacheService = {
  // Salvar no cache
  set: (key, data) => {
    const cacheData = {
      data,
      timestamp: Date.now()
    };
    try {
      localStorage.setItem(`cache_${key}`, JSON.stringify(cacheData));
    } catch (e) {
      console.warn('Cache storage full, clearing old data');
      cacheService.clearOld();
    }
  },

  // Buscar do cache
  get: (key) => {
    try {
      const cached = localStorage.getItem(`cache_${key}`);
      if (!cached) return null;

      const { data, timestamp } = JSON.parse(cached);
      const age = Date.now() - timestamp;

      // Se cache expirou, remover
      if (age > CACHE_DURATION) {
        localStorage.removeItem(`cache_${key}`);
        return null;
      }

      return data;
    } catch (e) {
      return null;
    }
  },

  // Invalidar cache específico
  invalidate: (key) => {
    localStorage.removeItem(`cache_${key}`);
  },

  // Limpar cache antigo
  clearOld: () => {
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.startsWith('cache_')) {
        try {
          const cached = localStorage.getItem(key);
          const { timestamp } = JSON.parse(cached);
          const age = Date.now() - timestamp;
          if (age > CACHE_DURATION) {
            localStorage.removeItem(key);
          }
        } catch (e) {
          localStorage.removeItem(key);
        }
      }
    });
  },

  // Limpar tudo
  clearAll: () => {
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.startsWith('cache_')) {
        localStorage.removeItem(key);
      }
    });
  }
};
